export default [
    {
		path: '/activity',
		redirect: '/reporting/engagement',
	},
	{
		path: '/activity/:memberId/:companyId',
		name: 'Social Activity Details',
		component: () => import('@/views/activity/SocialActivityDetails.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'social-activity']],
			nav: 'activity',
		}
	},
	{
		path: '/activity/view/:uuid/:activityId?',
		name: 'Social Activity Details',
		component: () => import('@/views/activity/SocialActivityDetail.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'social-activity']],
			nav: 'activity',
		}
	}
]